import styles from "./Stepper.module.scss";
import Step from "./Step";
import { Step as StepType } from "../../types";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  onUpdateStep,
  onUpdateSubStep,
} from "../../reducers/onboardingDataReducer";
import { onUpdateStep as onUpdateStepSecurities } from "../../reducers/securitiesReducer";

const Stepper = () => {
  const { container } = styles;
  const dispatch = useAppDispatch();

  const { onboardingData, securities } = useAppSelector((state) => state);

  const getStatusOfStep = (findStep: number) => {
    const finded = completedSteps?.find((step) => step === findStep);
    return finded ? "completed" : "disabled";
  };

  const template = useAppSelector((state) => state.activeTemplate);

  const { completedSteps, reachedSteps, step } =
    template.onboardingType === "SECURITIES"
      ? securities.stepData
      : onboardingData.stepData;

  const numericTemplateSteps = template?.steps?.filter(
    ({ step: templateStep, hideFromStepper }) =>
      typeof templateStep === "number" && !hideFromStepper
  );

  const handleStepClick = (
    step: string | number,
    substeps?: StepType[],
    disableBackNavigation?: boolean
  ) => {
    if (reachedSteps?.includes(Number(step)) && !disableBackNavigation) {
      dispatch(
        template.onboardingType === "SECURITIES"
          ? onUpdateStepSecurities(Number(step))
          : onUpdateStep(Number(step))
      );

      if (substeps) dispatch(onUpdateSubStep(1));
    }
  };

  return (
    <div className={container}>
      <div>
        {numericTemplateSteps?.map(
          (
            {
              step: templateStep,
              name,
              titleOfStep,
              disableBackNavigation,
              subSteps,
            },
            index
          ) => {
            const isDisabled =
              typeof disableBackNavigation === "function"
                ? disableBackNavigation(
                    onboardingData?.formValues || {},
                    getStatusOfStep(Number(templateStep) + 1)
                  )
                : !!disableBackNavigation;

            return (
              <button
                key={templateStep}
                onClick={() =>
                  handleStepClick(templateStep, subSteps, isDisabled)
                }
                disabled={
                  !(reachedSteps?.includes(Number(templateStep)) && !isDisabled)
                }
              >
                <Step
                  currentStep={
                    Number(templateStep) === step
                      ? "active"
                      : getStatusOfStep(Number(templateStep))
                  }
                  currentStepWasCompleted={
                    getStatusOfStep(Number(templateStep)) === "completed"
                  }
                  isFirstStep={index === 0}
                  isLastStep={index === numericTemplateSteps.length - 1}
                  subtitle={titleOfStep ?? (name || "")}
                  title={String(templateStep)}
                  nextStepStatus={getStatusOfStep(Number(templateStep) + 1)}
                  previousStepStatus={getStatusOfStep(Number(templateStep) - 1)}
                  disabledBackNavigation={isDisabled}
                />
              </button>
            );
          }
        )}
      </div>
    </div>
  );
};

export default Stepper;
